import { useEffect, useRef, useState } from "react";

const stats = [
  { v: 70, suf: "+", l: "Feature areas", d: "From attendance to payroll" },
  { v: 13, suf: "", l: "Built-in reports", d: "Audit-ready analytics" },
  { v: 90, suf: "%", l: "Faster payroll close", d: "Attendance-linked automation" },
  { v: 60, suf: "%", l: "Fewer HR queries", d: "With employee self-service" },
];

function Counter({ target, suffix }) {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        let s = 0, d = 900, start = performance.now();
        const step = (t) => {
          const p = Math.min((t - start) / d, 1);
          s = Math.floor(p * target);
          setN(s);
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
        io.disconnect();
      }
    });
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, [target]);
  return <span ref={ref}>{n}{suffix}</span>;
}

export default function Stats() {
  return (
    <section className="py-20 md:py-28 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <div key={i} className="bg-white rounded-2xl border border-slate-200 p-8 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all">
              <div className="text-5xl font-extrabold tracking-tighter text-[#1F1E4E]">
                <Counter target={s.v} suffix={s.suf} />
              </div>
              <div className="mt-3 text-sm font-bold text-[#1F1E4E]">{s.l}</div>
              <div className="text-xs text-slate-500 mt-1">{s.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
